import { createFileRoute, Outlet } from '@tanstack/react-router';
import { SEO } from 'components/Seo/Seo';
import { useSelector } from 'react-redux';
import { RootState } from 'store/reducer';
import messages from './messages';

export const Route = createFileRoute('/auth/reset-password')({
  component: ResetPasswordView,
});

function ResetPasswordView() {
  const { language } = useSelector(
    (rootState: RootState) => rootState.language,
  );

  const resetPasswordViewMessages = messages[language].seo;

  return (
    <>
      <SEO
        title={resetPasswordViewMessages.title}
        description={resetPasswordViewMessages.description}
        keywords={resetPasswordViewMessages.keywords}
        page="reset-password"
      />
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="max-w-3xl mx-auto">
          <div className="flex flex-col justify-center lg:px-8 sm:px-6 py-12">
            <Outlet />
          </div>
        </div>
      </div>
    </>
  );
}
